<!-- 商城雷达图 -->
<script setup>
import { onMounted, ref, reactive, watch, nextTick, onBeforeMount } from "vue"
import { getLangValue, truncate } from "@/utils/common"; //获取后端语言
import { dragRadarChart, initInvisibleGraphic } from "@/utils/dragRadarChart.js";
import { dragRadarChart1, initInvisibleGraphic as initInvisibleGraphic1 } from "@/utils/dragRadarChart1.js";
import { dragRadarChart3, initInvisibleGraphic as initInvisibleGraphic2, generateInitialData1 as generateInitialData } from '@/utils/dragRadarChart3.js';
import { getDatabaseTemplateRadarInfo, get_database_list_radar_map, } from "@/service/apiList/products.js";
import { getProductDetail, getProductsList, getFileUrl } from "@/service";
import { useRoute } from 'vue-router';
import i18n from "@/i18n"
const route = useRoute();
// 手感的值
const chart_hand = ref(null)
const chart_hand_dom = ref(null) //手感dom
const chart_skin = ref(null)
const chart_skin_dom = ref(null) //肤感dom
const chart_heat = ref(null)
const chart_heat_dom = ref(null) // 热湿舒适度
const chart_art = ref(null) // 新增美学舒适性
const chart_art_dom = ref(null) // 美学舒适性dom
const radarData = ref({}); //存储雷达图信息
const searchInfo = reactive({
    hand: [],
    skin: [],
    heat: [],
    art: [],
})
const shellLsit = ref([]) // 存储外层的数据
const selectedShell = ref('') // 选中的外层
const liningList = ref([]) // 存储内层的数据
const selectedLining = ref('') // 选中的内层
const step = ref(0) // 步骤  0:显示雷达图  1：显示对比图   2：显示推荐产品
const productList = ref([]) // 推荐产品列表
const role_key = ref('') // 产品的role_key
const hscode_id = ref('') // 产品的hscode_id
const fileList = ref([]) // 存储图片列表
const selectedProduct = ref(''); // 选择的产品
//手感chart
const initHandChart = () => {
    if (chart_hand.value) {
        const width = chart_hand.value.offsetWidth;
        const height = chart_hand.value.offsetHeight;
        searchInfo.hand = radarData.value.hand_feeling.map(() => 1)
        let options = {
            indicator: radarData.value.hand_feeling.map(item => {
                return {
                    name: item,
                    max: 1,
                }
            }),
            chartData: radarData.value.hand_feeling.map(() => 1),
            color: "#50C3E6",
            type: "hand",
            width: width,
            height: height,
            name: getLangValue("radar_chart.feel"),
            chartDom: chart_hand.value,
        };
        chart_hand_dom.value = dragRadarChart(
            options,
            calbackFunc,
            resetChart,
            '22%'
        );
    }
}

// 肤感
const initSkinChart = () => {
    if (chart_skin.value) {
        const width = chart_skin.value.offsetWidth;
        const height = chart_skin.value.offsetHeight;
        searchInfo.skin = radarData.value.skin_feeling.map(() => 1)
        let options = {
            indicator: radarData.value.skin_feeling.map(item => {
                return {
                    name: item,
                    max: 1,
                }
            }),
            chartData: radarData.value.skin_feeling.map(() => 1),
            color: "#13C56B",
            type: "skin",
            width: width,
            height: height,
            name: getLangValue("radar_chart.skin"),
            chartDom: chart_skin.value,
        };
        chart_skin_dom.value = dragRadarChart(
            options,
            calbackFunc,
            resetChart,
            '22%'
        );
    }
}
// 热舒适度
const initHeatChart = () => {
    if (chart_heat.value) {
        const width = chart_heat.value.offsetWidth;
        const height = chart_heat.value.offsetHeight;
        searchInfo.heat = radarData.value.heat_and_humidity_comfort.map(() => 1)
        let options = {
            indicator: radarData.value.heat_and_humidity_comfort.map(item => {
                return {
                    name: item,
                    max: 1,
                }
            }),
            chartData: radarData.value.heat_and_humidity_comfort.map(() => 1),
            color: "#ED5E5E",
            type: "heat",
            width: width,
            height: height,
            name: getLangValue("radar_chart.heat"),
            chartDom: chart_heat.value,
        };
        chart_heat_dom.value = dragRadarChart1(
            options,
            calbackFunc,
            resetChart,
            '26%'
        );
    }

}

// 美学舒适性
const initArtChart = () => {
    if (chart_art.value) {
        const width = chart_art.value.offsetWidth;
        const height = chart_art.value.offsetHeight;
        searchInfo.art = radarData.value.aesthetic_comfort.map(() => 1)
        let options = {
            // 动态获取
            indicator: radarData.value.aesthetic_comfort.map(item => {
                return {
                    name: item,
                    max: 1,
                }
            }),
            chartData: radarData.value.aesthetic_comfort.map(() => 1),
            color: "#ED5E5E",
            type: "art",
            width: width,
            height: height,
            name: getLangValue("radar_chart.art"),
            chartDom: chart_art.value,
        };
        chart_art_dom.value = dragRadarChart3(
            options,
            calbackFunc,
            resetChart,
            '26%'
        );
    }

}


const getRagarInfo = async () => {
    // 根据产品类型获取雷达图的角标信息
    const resp = await getDatabaseTemplateRadarInfo({ role_key: role_key.value });
    if (resp.code == 0) {
        // 手感 肤感 热舒适度 美学舒适性
        radarData.value = resp.payload;
    }
}

const calbackFunc = (data) => {
    if (data.type == "hand") {
        //  0 1调换位置
        const [a, b, c, d] = data.data
        searchInfo.hand = [...[a, b, c, d]];
    } else if (data.type == "skin") {
        searchInfo.skin = [...data.data];
    } else if (data.type == "heat") {
        searchInfo.heat = [...data.data];
    } else {
        searchInfo.art = [...data.data];
    }
}

const update_hand_data = (hand_data, selectedProduct = '') => {
    // 手感数据更新
    let { comprehensive_degree, smooth, soft, warmth } = hand_data.score_hand_feeling || hand_data?.children?.score_hand_feeling || hand_data?.children?.[0].children?.[0].score_hand_feeling || {};
    let hand_feel_data = [
        comprehensive_degree,
        smooth,
        soft,
        warmth,
    ]
    if (hand_feel_data.every(item => item == 0)) {
        // 创建4随机数小数数组 0-1之间的随机数 小于[0.6, 0.6, 0.8, 0.8]
        let data = [];
        for (let i = 0; i < hand_feel_data.length; i++) {
            data.push(Math.random() * (hand_feel_data[i] - 0.6) + 0.6);
        }
        hand_feel_data = selectedProduct ? data : [0.6, 0.6, 0.8, 0.8];
    }
    console.log(hand_feel_data);
    let option = chart_hand_dom.value.getOption();
    let mm = {
        // TODO:
        name: truncate('xx'),
        value: hand_feel_data,
        coordinateSystem: 'polar',
        id: selectedProduct,
        label: {
            show: false,
            formatter: (params) => {
                return params.value;
            },
            color: selectedProduct ? "#f0f2f6" : '#70c1e2'
        },
        areaStyle: {
            color: selectedProduct ? "#f0f2f6" : '#70c1e2',
            opacity: 0.2
        },
        lineStyle: {
            type: 'solid',
            width: 1,
            opacity: 0.5
        }
    }
    // console.log(option.series[1].data.push);
    if (!selectedProduct) {
        if (option.series[1].data.length == 2) {
            option.series[1].data.pop()
        }
        option.series[1].data.push(mm);
    } else {
        // 先删除旧数据
        let index = option.series[1].data.findIndex(item => item.id == selectedProduct);
        if (index != -1) {
            option.series[1].data.splice(index, 1);
        }
        option.series[1].data.push(mm);
    }

    // 更新
    chart_hand_dom.value.setOption(option);
    let data = [
        [0, searchInfo.hand[0]],
        [-searchInfo.hand[1], 0],
        [0, -searchInfo.hand[2]],
        [searchInfo.hand[3], 0]
    ];
    initInvisibleGraphic(chart_hand_dom.value, data, searchInfo.hand, 10, '#50C3E6', 'hand', chart_hand.value.offsetWidth, chart_hand.value.offsetHeight, getLangValue("radar_chart.feel"), calbackFunc);
}

const update_skin_data = (skin_data, selectedProduct = '') => {
    // 肤感数据更新
    let { comprehensive_degree, cool, pricking, stiff } = skin_data.score_skin_feeling || skin_data?.children?.score_skin_feeling || skin_data?.children?.[0].children?.[0].score_skin_feeling || {}
    let hand_feel_data = [
        comprehensive_degree,
        cool,
        pricking,
        stiff,
    ]
    if (hand_feel_data.every(item => item == 0)) {
        // 创建4随机数小数数组 0-1之间的随机数 小于[0.6, 0.6, 0.8, 0.8]
        let data = [];
        for (let i = 0; i < hand_feel_data.length; i++) {
            data.push(Math.random() * (hand_feel_data[i] - 0.6) + 0.6);
        }
        hand_feel_data = selectedProduct ? data : [0.6, 0.6, 0.8, 0.8];
    }
    let option = chart_skin_dom.value.getOption()
    let mm = {
        // TODO:
        name: truncate('xx'),
        value: hand_feel_data,
        coordinateSystem: 'polar',
        label: {
            show: false,
            formatter: (params) => {
                return params.value;
            },
            color: selectedProduct ? "#f0f2f6" : '#13C56B'
        },
        areaStyle: {
            color: selectedProduct ? "#f0f2f6" : '#13C56B',
            opacity: 0.2
        },
        lineStyle: {
            type: 'solid',
            width: 1,
            opacity: 0.5
        }
    }
    // console.log(option.series[1].data.push);
    if (!selectedProduct) {
        if (option.series[1].data.length == 2) {
            option.series[1].data.pop()
        }
        option.series[1].data.push(mm);
    } else {
        if (option.series[1].data.length == 3) {
            option.series[1].data.pop()
        }
        option.series[1].data.push(mm);
    }
    // 更新
    chart_skin_dom.value.setOption(option)
    let data = [
        [0, searchInfo.skin[0]],
        [-searchInfo.skin[1], 0],
        [0, -searchInfo.skin[2]],
        [searchInfo.skin[3], 0]
    ];
    initInvisibleGraphic(chart_skin_dom.value, data, searchInfo.skin, 10, '#13C56B', 'skin', chart_skin.value.offsetWidth, chart_skin.value.offsetHeight, getLangValue("radar_chart.skin"), calbackFunc);
}

const update_heat_data = (heat_data, selectedProduct = '') => {
    // 更新热湿舒适度信息
    // 热��适度数据更新
    const { comfort = 0, heat = 0, humidity = 0 } = heat_data?.score_heat_and_humidity_comfort || {}
    let heat_and_humidity_comfort_data = [
        comfort,
        heat,
        humidity,
    ]
    if (comfort == 0 && heat == 0 && humidity == 0) {
        // 创建3随机数小数数组 0-1之间的随机数 小于[0.6, 0.5, 0.3]
        let data = [];
        for (let i = 0; i < heat_and_humidity_comfort_data.length; i++) {
            data.push(Math.random() * (heat_and_humidity_comfort_data[i] - 0.6) + 0.6);
        }
        heat_and_humidity_comfort_data = selectedProduct ? data : [0.6, 0.5, 0.3]
    }
    let option = chart_heat_dom.value.getOption()
    let mm = {
        // TODO:
        name: truncate('xx'),
        value: heat_and_humidity_comfort_data,
        coordinateSystem: 'polar',
        label: {
            show: false,
            formatter: (params) => {
                return params.value;
            },
            color: selectedProduct ? "#f0f2f6" : '#ED5E5E',
        },
        areaStyle: {
            color: selectedProduct ? "#f0f2f6" : '#ED5E5E',
            opacity: 0.2
        },
        lineStyle: {
            type: 'solid',
            width: 1,
            opacity: 0.5
        }
    }
    // console.log(option.series[1].data.push);
    if (!selectedProduct) {
        if (option.series[1].data.length == 2) {
            option.series[1].data.pop()
        }
        option.series[1].data.push(mm);
    } else {
        if (option.series[1].data.length == 3) {
            option.series[1].data.pop()
        }
        option.series[1].data.push(mm);
    }
    // 更新
    console.log(option);
    chart_heat_dom.value.setOption(option)
    let data = [
        [0, searchInfo.heat[0]],
        [-searchInfo.heat[1], -0.5],
        [searchInfo.heat[2], -0.5],
    ];
    initInvisibleGraphic1(chart_heat_dom.value, data, searchInfo.heat, 10, '#13C56B', 'heat', chart_heat.value.offsetWidth, chart_heat.value.offsetHeight, getLangValue("radar_chart.heat"), calbackFunc);
}

const update_art_data = (art_data, selectedProduct = '') => {
    // 更新美学舒适性
    // 肤感数据更新
    // const { comprehensive_degree, cool, pricking, stiff } = skin_data.score_skin_feeling
    let aesthetic_comfort_data = [...Object.values(art_data?.score_aesthetic_comfort)]
    console.log(aesthetic_comfort_data);
    if (aesthetic_comfort_data.every(item => item == 0)) {
        // 创建4随机数小数数组 0-1之间的随机数 小于[0.6, 0.6, 0.8, 0.8]
        let data = [];
        let data1 =[];
        for (let i = 0; i < aesthetic_comfort_data.length; i++) {
            data.push(Math.random() * (aesthetic_comfort_data[i] - 0.6) + 0.6);
            data1.push(0.6);
        }
        aesthetic_comfort_data = selectedProduct ? data : data1;
    }
    let option = chart_art_dom.value.getOption()
    let mm = {
        // TODO:
        name: truncate('xx'),
        value: aesthetic_comfort_data,
        coordinateSystem: 'polar',
        label: {
            show: false,
            formatter: (params) => {
                return params.value;
            },
            color: selectedProduct ? "#f0f2f6" : '#13C56B',
        },
        areaStyle: {
            color: selectedProduct ? "#f0f2f6" : '#13C56B',
            opacity: 0.2
        },
        lineStyle: {
            type: 'solid',
            width: 1,
            opacity: 0.5
        }
    }
    // console.log(option.series[1].data.push);
    if (!selectedProduct) {
        if (option.series[1].data.length == 2) {
            option.series[1].data.pop()
        }
        option.series[1].data.push(mm);
    } else {
        if (option.series[1].data.length == 3) {
            option.series[1].data.pop()
        }
        option.series[1].data.push(mm);
    }
    // 更新
    chart_art_dom.value.setOption(option)
    // 根据现在的值生成新的坐标
    const { data } = generateInitialData(searchInfo.art)
    initInvisibleGraphic2(chart_art_dom.value, data, searchInfo.art, 10, 'skin', getLangValue("radar_chart.art"), calbackFunc);
}

const resetChart = (val) => {
    console.log("resetChart", val);
}

const setToken = async () => {
    // 路由获取的token存到缓存里面
    let data = {
        token: route.query.company_id || '66c2ceed14b2c56626a97835',
        timestamp: route.query.timestamp || '',
    }
    sessionStorage.setItem("set_menu_list", JSON.stringify(data));
    // sessionStorage.setItem("language", route.query.lang || 'en')
}


const getAllRadarInfo = async (selectedProduct = '') => {
    // 获取所有的信息 详情信息  雷达图信息
    // 如果是织物 直接获取数据
    // 如果是服装 需要判断下面有几个织物  一个内外层都是他    多个就要分内外层  切换展示
    const resp = await get_database_list_radar_map(selectedProduct || route.query.product_id);
    // 织物的情况  
    if (resp.payload?.list_hand_feeling?.length == 0 && resp.payload?.list_skin_feeling?.length == 0) {
        // 肯定是织物
        shellLsit.value = [] // 没有内外层
        liningList.value = [] // 没有内外层
        // 就直接使用外层的数据
        // 手感数据
        if (route.query.type == 'hand') {
            update_hand_data(resp.payload, selectedProduct);
        }
        // 肤感数据
        if (route.query.type == 'skin') {
            update_skin_data(resp.payload, selectedProduct);
        }
    }
    // 服装的情况
    if (resp.payload?.list_hand_feeling?.length == 1 && resp.payload?.list_skin_feeling?.length == 1) {
        // 服装数据只有一个数据
        shellLsit.value = [] // 没有内外层
        liningList.value = [] // 没有内外层
        // update_hand_data(resp.payload.list_hand_feeling[0]);
        // update_skin_data(resp.payload.list_skin_feeling[0]);
        // 手感数据
        if (route.query.type == 'hand') {
            update_hand_data(resp.payload.list_hand_feeling[0], selectedProduct);
        }
        // 肤感数据
        if (route.query.type == 'skin') {
            update_skin_data(resp.payload.list_hand_feeling[0], selectedProduct);
        }
    }
    // 服装的情况 多个织物
    if (resp.payload?.list_hand_feeling?.length > 1 && resp.payload?.list_skin_feeling?.length > 1) {
        // 多个织物  去获取内外层
        // 手感数据
        shellLsit.value = resp.payload.list_hand_feeling?.filter(item => item.layer == 'shell')
        // 肤感数据
        liningList.value = resp.payload.list_skin_feeling?.filter(item => item.layer == 'lining')
        // 手感数据 默认选中第一个
        selectedShell.value = shellLsit.value[0].pid
        // update_hand_data(shellLsit.value[0]);
        if (route.query.type == 'hand') {
            update_hand_data(shellLsit.value[0], selectedProduct);
        }
        // 肤感数据 默认选中第一个
        selectedLining.value = liningList.value[0].pid;
        // update_skin_data(liningList.value[0]);
        if (route.query.type == 'skin') {
            update_skin_data(shellLsit.value[0], selectedProduct);
        }
    }
    // 服装热湿舒适度  只有服装才有
    if (route.query.type == 'heat') {
        // 这个显示了说明有热湿舒适度
        update_heat_data(resp.payload, selectedProduct);
    }
    // 展示美学舒适性
    if (route.query.type == 'art' && resp.payload?.score_aesthetic_comfort) {
        update_art_data(resp.payload, selectedProduct)
    }
}

const next = () => {
    // 下一步

    if (step.value == 2) {
        return
    }
    step.value++;
}

const prev = () => {
    // 下一步
    if (step.value == 0) {
        return
    }
    step.value--;
}

const back = () => {
    // 返回
    step.value = 0;
}

const getProductList = async () => {
    // 获取推荐产品
    // 这里可以调用接口获取推荐的产品
    // 目前只是一个占位符
    console.log("获取推荐产品");
    let params = {
        role_key: role_key.value,
        hscode_id: hscode_id.value,
        page: 0
    }
    console.log(searchInfo.hand);
    if (route.query.type == 'hand') {
        params.hand_feeling = searchInfo.hand
    } else if (route.query.type == 'skin') {
        params.skin_feeling = searchInfo.skin;
    } else if (route.query.type == 'heat') {
        params.heat_and_humidity_comfort = searchInfo.heat;
    } else if (route.query.type == 'art') {
        params.aesthetic_comfort = searchInfo.art;
    }
    const resp = await getProductsList(params);
    if (resp.code == 0) {
        // 获取成功
        productList.value = resp.payload?.data;
    } else {
        console.error("获取推荐产品失败", resp.message);
    }

}

const getProductDetailByid = async () => {
    // 获取产品详情
    const resp = await getProductDetail(route.query.product_id);
    if (resp.code == 0) {
        // 处理产品详情
        role_key.value = resp.payload.production_line?.database_template?.role_key;
        hscode_id.value = resp.payload.production_line?.database_template?.hscode?.id;
        console.log(role_key.value);
        console.log(hscode_id.value);
    } else {
        console.error("获取产品详情失败", resp.message);
    }
}

onBeforeMount(() => {
    const language = route.query.lang == 'en' ? route.query.lang : 'ch';
    sessionStorage.setItem("language", language);
    i18n.global.locale = language;
})

const showDetail = ({ id }) => {
    // 展示详情
    console.log(id);
    selectedProduct.value = id;
    getAllRadarInfo(id);
}

onMounted(async () => {
    await getProductDetailByid();
    await setToken();
    await getRagarInfo();
    nextTick(() => {
        if (route.query.type == 'hand') {
            initHandChart();
        } else if (route.query.type == 'skin') {
            // 初始化肤感图
            initSkinChart();
        } else if (route.query.type == 'heat') {
            // 初始化热舒适度图
            initHeatChart();
        } else if (route.query.type == 'art') {
            // 初始化美学舒适性图
            initArtChart();
        }
    })

})

watch(step, () => {
    console.log(step.value);
    if (step.value == 1) {
        getAllRadarInfo();
    } else if (step.value == 2) {
        // 推荐产品
        getProductList();
    } else if (step.value == 0) {
        // 回到雷达图
        if (route.query.type == 'hand') {
            initHandChart();
        } else if (route.query.type == 'skin') {
            // 初始化肤感图
            initSkinChart();
        } else if (route.query.type == 'heat') {
            // 初始化热舒适度图
            initHeatChart();
        } else if (route.query.type == 'art') {
            // 初始化美学舒适性图
            initArtChart();
        }
    }
},);

watch(productList, () => {
    fileList.value = []
    let imageList = productList.value.filter(item => item['picture'].length > 0).map((item) => item['picture'][0])
    // 重复图片 去重
    imageList = [...new Set(imageList)]
    let imgStr = imageList.join(',')
    if (imgStr)
        getFileUrl({ attachments: imgStr }).then(resp => {
            if (resp) {
                fileList.value = resp.payload
                // console.log(fileList.value);
            }
        })

},)

</script>

<template>
    <div class="my-radar bg-white" style="height: 100vh;">
        <div class="d-flex justify-content-center">
            <div style="width: 360px;position: relative;">
                <!-- 手感charts -->
                <div class="p-3" style="border-bottom: 1px solid rgba(233, 235, 236, 1);"
                    v-if="route.query.type == 'hand' && radarData.hand_feeling?.length">
                    <div class="d-flex justify-content-between  align-items-center cursor-pointer ">
                        <span style="color: rgba(149, 153, 173, 1); font-size: 18px;font-weight: bold;">
                            {{ getLangValue('radar_chart.feel') }}</span>
                    </div>
                    <div class="pt-3">
                        <div class="d-flex justify-content-between my-2 align-items-center"
                            :class="step < 1 ? '' : 'disabledRadar'">
                            <div class="flex-1 mx-1">
                                <div ref="chart_hand" id="productshandChartId" style="height: 220px; width: 310px">
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="flex-wrap: wrap;">
                            <!-- 去掉内外层选择  默认手感是外层  肤感是内层 -->
                            <div class="mb-1 mx-1" style="flex: 1; min-width: 45%;" v-if="shellLsit.length">
                                <div class="mb-1">
                                    <span style="color: black; font-size: 12px;">{{
                                        getLangValue('radar_chart.layer') }}:</span>
                                </div>
                                <el-select style="width: 100%; height: 37.5px;" v-model="selectedShell" filterable
                                    placeholder="" size="mini" @change="changeLayer(1)">
                                    <el-option v-for="(item, key) in shellLsit" :key="key" :label="item.name"
                                        :value="item.pid"></el-option>
                                </el-select>
                            </div>
                            <div class="mb-1 mx-1" style="flex: 1; min-width: 45%"
                                v-for="(item, k) in radarData.hand_feeling" :key="k">
                                <div class="mb-1">
                                    <span style="color: black; font-size: 12px;">{{ item }}:</span>
                                </div>
                                <input v-model="searchInfo.hand[k]" type="number" disabled
                                    class="form-control form-control-sm form-control-icon">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 肤感charts -->
                <div class="p-3" style="border-bottom: 1px solid rgba(233, 235, 236, 1);"
                    v-if="route.query.type == 'skin' && radarData.skin_feeling?.length">
                    <div class="d-flex justify-content-between  align-items-center cursor-pointer ">
                        <span style="color: rgba(149, 153, 173, 1); font-size: 18px;font-weight: bold;">
                            {{ getLangValue('radar_chart.skin') }}</span>
                    </div>
                    <div class="pt-3">
                        <div class="d-flex justify-content-between my-2 align-items-center"
                            :class="step < 1 ? '' : 'disabledRadar'">
                            <div class="flex-1  mx-1">
                                <div ref="chart_skin" id="productskinChartId" style="height: 220px; width: 100%">
                                </div>
                            </div>

                        </div>
                        <div class="d-flex" style="flex-wrap: wrap;">
                            <div class="mb-1 mx-1" style="flex: 1; min-width: 45%;" v-if="liningList.length">
                                <div class="mb-1">
                                    <span style="color: black; font-size: 12px;">{{
                                        getLangValue('radar_chart.layer') }}:</span>
                                </div>
                                <el-select style="width: 100%; height: 37.5px;" v-model="selectedLining" filterable
                                    placeholder="" size="mini" @change="changeLayer(2)">
                                    <el-option v-for="(item, key) in liningList" :key="key" :label="item.name"
                                        :value="item.pid"></el-option>
                                </el-select>
                            </div>
                            <div class="mb-1 mx-1" style="flex: 1; min-width: 45%"
                                v-for="(item, k) in radarData.skin_feeling" :key="k">
                                <div class="mb-1">
                                    <span style="color: black; font-size: 12px;">{{ item }}:</span>
                                </div>
                                <input v-model="searchInfo.skin[k]" type="number" disabled
                                    class="form-control form-control-sm form-control-icon">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 热舒适度charts -->
                <div class="p-3 " style="border-bottom: 1px solid rgba(233, 235, 236, 1);"
                    v-if="route.query.type == 'heat' && radarData.heat_and_humidity_comfort?.length">
                    <div class="d-flex justify-content-between  align-items-center cursor-pointer ">
                        <span style="color: rgba(149, 153, 173, 1); font-size: 18px;font-weight: bold;">
                            {{ getLangValue('radar_chart.heat') }}</span>
                    </div>
                    <div class="pt-3">
                        <div class="d-flex justify-content-between my-2 align-items-center"
                            :class="step < 1 ? '' : 'disabledRadar'">
                            <div class="flex-1">
                                <div ref="chart_heat" id="productheatChartId"
                                    style="height: 220px; width: 100%; min-width: 220px">
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="flex-wrap: wrap;">
                            <div class="mb-1 mx-1" style="flex: 1; min-width: 45%"
                                v-for="(item, k) in radarData.heat_and_humidity_comfort" :key="k">
                                <div class="mb-1">
                                    <span style="color: black; font-size: 12px;">{{ item }}:</span>
                                </div>
                                <input v-model="searchInfo.heat[k]" type="number" disabled
                                    class="form-control form-control-sm form-control-icon">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 美学舒适性charts -->
                <div class="p-3 " style="border-bottom: 1px solid rgba(233, 235, 236, 1);"
                    v-if="route.query.type == 'art' && radarData.aesthetic_comfort?.length">
                    <div class="d-flex justify-content-between  align-items-center cursor-pointer ">
                        <span style="color: rgba(149, 153, 173, 1); font-size: 18px;font-weight: bold;">
                            {{ getLangValue('radar_chart.art') }}</span>
                    </div>
                    <div class="pt-3">
                        <div class="d-flex justify-content-between my-2 align-items-center"
                            :class="step < 1 ? '' : 'disabledRadar'">
                            <div class="flex-1">
                                <div ref="chart_art" id="productartChartId"
                                    style="height: 220px; width: 100%; min-width: 220px">
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="flex-wrap: wrap;">
                            <div class="mb-1 mx-1" style="flex: 1; min-width: 45%"
                                v-for="(item, k) in radarData.aesthetic_comfort" :key="k">
                                <div class="mb-1">
                                    <span style="color: black; font-size: 12px;">{{ item }}:</span>
                                </div>
                                <input v-model="searchInfo.art[k]" type="number" disabled
                                    class="form-control form-control-sm form-control-icon">
                            </div>
                        </div>
                    </div>
                </div>
                <div style="position: absolute; right: -200px; top:50%; font-size: 16px; font-weight: 500;" class="text-muted">
                    <span v-if="step == 0">{{ getLangValue('b2c.step_1_info') }}</span>
                    <span v-else-if="step == 1">{{ getLangValue('b2c.step_2_info') }}</span>
                </div>
            </div>
            <div class="flex-1 p-3" v-show="step == 2"
                v-if="radarData.aesthetic_comfort?.length || radarData.hand_feeling?.length || radarData.skin_feeling?.length || radarData.heat_and_humidity_comfort?.length">
                <div class="text-left" style="font-size: 18px;font-weight: bold;">
                    {{getLangValue('b2c.recommended_products')}}
                </div>
                <div>
                    <span class="text-muted" style="font-size: 16px; font-weight: 500;" >{{ getLangValue('b2c.step_3_info') }}</span>
                <div class="productList my-scroll-bar" style="max-height: 400px;overflow-y: auto;">
                    <div v-for="(product, key) in productList" :key="key" class="product-item my-2"
                        :class="{ 'active': selectedProduct == product.id }" @click="showDetail(product)"
                        style="color: #212529;">
                        <img style="width: 40px; height: 40px;" class="me-2"
                            :src="product.picture?.length && fileList.length ? fileList.filter(item => item.id === product['picture'][0]).length ? fileList.filter(item => item.id === product['picture'][0])[0].url : '' : ''">
                        {{ product.name }}
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between p-3"
            v-if="radarData.aesthetic_comfort?.length || radarData.hand_feeling?.length || radarData.skin_feeling?.length || radarData.heat_and_humidity_comfort?.length">
            <button type="button" class="btn btn-success me-3 sm" @click="prev" style="min-width: 100px;"
                v-if="step == 1">
                {{getLangValue('b2c.prev')}}
            </button>
            <button type="button" class="btn btn-success me-3 sm" @click="next" style="min-width: 100px;"
                v-if="step < 2">
                {{getLangValue('b2c.next')}}
            </button>
            <button type="button" class="btn btn-success me-3 sm" @click="back" style="min-width: 100px;"
                v-if="step == 2">
                {{getLangValue('b2c.back')}}
            </button>
        </div>
        <div
            v-if="radarData.aesthetic_comfort?.length == 0 && radarData.hand_feeling?.length == 0 && radarData.skin_feeling?.length == 0 && radarData.heat_and_humidity_comfort?.length == 0">
            <Empty />
        </div>
    </div>
</template>

<style scoped lang="scss">
.disabledRadar {
    background-color: hsla(0, 0%, 80%, .15);
    pointer-events: none;
    opacity: .8;
    cursor: not-allowed;
}

.product-item.active {
    background-color: #f0f2f6;
    color: #fff;
}
</style>